import React from 'react';
import { Sparkles, Lightbulb } from 'lucide-react';
import { ComparisonCard } from './ComparisonCard';

export const AIComparisonsSection = ({ comparisons, loading, onExplore }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-slate-800">AI-Suggested Comparisons</h3>
            <p className="text-sm text-slate-500">High-variance pairs with similar context for actionable insights</p>
          </div>
        </div>
        {!loading && comparisons.length > 0 && (
          <span className="text-sm text-slate-500">{comparisons.length} suggestions</span>
        )}
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(3)].map((_, i) => (
            <div key={`comp-skel-${i}`} className="bg-slate-100 rounded-xl h-64 animate-pulse"></div>
          ))}
        </div>
      ) : comparisons.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comparisons.map((comparison, index) => (
            <ComparisonCard key={`comp-${index}`} comparison={comparison} onExplore={onExplore} />
          ))}
        </div>
      ) : (
        <div className="bg-slate-50 border border-dashed border-slate-300 rounded-xl p-8 text-center">
          <Lightbulb className="h-8 w-8 text-slate-400 mx-auto mb-2" />
          <p className="text-slate-600 font-medium">No high-variance comparisons found</p>
          <p className="text-sm text-slate-500 mt-1">Try adjusting your filters or date range to find meaningful comparisons</p>
        </div>
      )}
    </div>
  );
};
